import { render } from 'solid-js/web';
import './index.css';
import Home from './routes/public/Home';
import Radio from './routes/public/Radio';
import Kiosk from './routes/zone/Kiosk';
import Pairing from './routes/zone/Pairing';
import { saveDevice } from './api';

function App() {
  const path = location.pathname;
  const zone = path.match(/^\/z\/([A-Za-z0-9_-]{8,128})\/?$/);
  if (zone) return <Kiosk token={zone[1]} />;
  if (path === '/pair' || path === '/z' || path === '/z/')
    return <Pairing onPaired={(d, token) => { saveDevice(d); location.replace(`/z/${token}`); }} />;
  if (path === '/' || path === '') return <Home />;
  return <Radio />;
}

render(() => <App />, document.getElementById('root')!);
